import { useState } from "react";
import { contributorKey } from "../lib/contributor-key";
export function PhotoAttach({ reviewId }: { reviewId: string }) {
	const [file, setFile] = useState<File | null>(null),
		[checks, setChecks] = useState([false, false, false]),
		[message, setMessage] = useState(""),
		[busy, setBusy] = useState(false);
	async function upload() {
		if (!file || checks.some((v) => !v)) return;
		setBusy(true);
		try {
			if (file.size > 12 * 1024 * 1024 || !file.type.startsWith("image/"))
				throw new Error("12MB 이하 사진 한 장을 골라 주세요.");
			const image = await createImageBitmap(file);
			const scale = Math.min(1, 1600 / Math.max(image.width, image.height));
			const canvas = document.createElement("canvas");
			canvas.width = Math.round(image.width * scale);
			canvas.height = Math.round(image.height * scale);
			const context = canvas.getContext("2d");
			if (!context) throw new Error("사진을 처리하지 못했어요.");
			context.drawImage(image, 0, 0, canvas.width, canvas.height);
			image.close();
			const blob = await new Promise<Blob | null>((resolve) =>
				canvas.toBlob(resolve, "image/jpeg", 0.82),
			);
			if (!blob || blob.size > 1_500_000)
				throw new Error(
					"변환한 사진이 1.5MB보다 커요. 더 작은 사진을 골라 주세요.",
				);
			const response = await fetch(`/api/tips/${reviewId}/photo`, {
				method: "POST",
				headers: {
					"content-type": "image/jpeg",
					"x-contributor-key": contributorKey(),
					"x-photo-attestation": "no_people,no_performance,own_photo",
				},
				body: blob,
			});
			if (!response.ok)
				throw new Error("한 줄은 공개돼 있어요. 사진만 다시 올려 주세요.");
			setMessage(
				"사진은 확인 뒤 공개돼요. 내가 공개한 글에서 상태를 볼 수 있어요.",
			);
			setFile(null);
		} catch (error) {
			setMessage(
				error instanceof Error && /[가-힣]/.test(error.message) ? error.message : "사진을 읽거나 올리지 못했어요. 한 줄은 그대로예요. 다른 사진으로 다시 시도해 주세요.",
			);
		} finally {
			setBusy(false);
		}
	}
	return (
		<details className="stack">
			<summary>사진 1장 더하기</summary>
			<p>
				공연 시작 전이나 끝난 뒤 빈 무대만 올려 주세요. 기기와 서버에서
				위치정보를 지우고 확인 뒤 공개해요.
			</p>
			<input
				type="file"
				accept="image/*"
				aria-label="시야 사진 한 장"
				onChange={(e) => setFile(e.target.files?.[0] ?? null)}
			/>
			{[
				"얼굴·다른 관객을 알아볼 수 없어요",
				"공연 중에 찍지 않았어요",
				"내가 찍은 사진이에요",
			].map((label, i) => (
				<label className="check-item" key={label}>
					<input
						type="checkbox"
						checked={checks[i] ?? false}
						onChange={(e) =>
							setChecks(checks.map((v, n) => (n === i ? e.target.checked : v)))
						}
					/>
					{label}
				</label>
			))}
			<button
				className="button"
				disabled={!file || checks.some((v) => !v) || busy}
				onClick={() => void upload()}
			>
				{busy ? "사진을 올리고 있어요" : "확인한 사진 올리기"}
			</button>
			<p role="status">{message}</p>
		</details>
	);
}
